module.exports = __webpack_public_path__ + "static/img/GuidePage_txt.bbe8ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/GuidePage_txt.png
// module id = VT7F
// module chunks = 1